export default "__VITE_ASSET__BMfdBddu__"